import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-amount-subscription',
  templateUrl: './amount-subscription.component.html',
  styleUrls: ['./amount-subscription.component.scss']
})
export class AmountSubscriptionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
